import dayjs from 'dayjs'

// Prefer the values stored on the product row; fall back to price + margin so
// rows without them still report a number instead of NaN.
const mediaSpendOf = product => {
  const stored = parseFloat(product.mediaSpend)
  if (Number.isFinite(stored)) return stored
  const price = parseFloat(product.price) || 0
  const margin = parseFloat(product.margin) || 0
  return price - price * (margin / 100)
}

const grossProfitOf = product => {
  const stored = parseFloat(product.grossProfit)
  if (Number.isFinite(stored)) return stored
  return (parseFloat(product.price) || 0) - mediaSpendOf(product)
}

// Gross margin as a percentage of revenue. Media spend is price minus gross
// profit by definition, so the two sum back to the price.
const marginPercent = (grossProfit, mediaSpend) => {
  const revenue = grossProfit + mediaSpend
  if (revenue <= 0) return 0
  return (grossProfit / revenue) * 100
}

export const calculateCSAPaymentSchedule = (deal, products) => {
  if (!products || !products?.length) return []

  // Step 1: Determine the earliest start date and the latest end date
  const startDate = dayjs.min(products.map(product => dayjs(product.startDate)))
  const endDate = dayjs.max(products.map(product => dayjs(product.endDate)))

  // Step 2: Calculate the total number of months between the start and end dates
  const totalPayments = deal && deal.numberOfPayments ? deal.numberOfPayments : 2

  // Step 3: Calculate the total contract amount
  const totalAmount = products.reduce((sum, product) => sum + parseFloat(product.price), 0)
  const totalMediaSpend = products.reduce((sum, product) => sum + mediaSpendOf(product), 0)
  const totalGrossProfit = products.reduce((sum, product) => sum + grossProfitOf(product), 0)

  // Step 4: Calculate the monthly payment amount
  const monthlyPayment = (totalAmount / totalPayments).toFixed(2)
  // A CSA splits the whole contract into equal payments, so gross profit and
  // media spend are split the same way rather than recomputed per month.
  const monthlyGrossProfit = (totalGrossProfit / totalPayments).toFixed(2)
  const monthlyMediaSpend = (totalMediaSpend / totalPayments).toFixed(2)

  // Step 5: Generate the payment schedule
  const paymentSchedule = []
  let currentMonth = startDate.startOf('month')

  for (let i = 0; i < totalPayments; i++) {
    paymentSchedule.push({
      month: currentMonth.format('MMMM'),
      year: currentMonth.year(),
      paymentAmount: parseFloat(monthlyPayment),
      grossProfit: parseFloat(monthlyGrossProfit),
      mediaSpend: parseFloat(monthlyMediaSpend),
      grossMargin: parseFloat(marginPercent(totalGrossProfit, totalMediaSpend).toFixed(2)),
      productsAssociated: products.map(product => product.productName), // or customize as needed
    })
    currentMonth = currentMonth.add(1, 'month')
  }

  return paymentSchedule
}

// import dayjs from 'dayjs'

// export const calculateCSAPaymentSchedule = deal => {
//   if (!deal || !deal.products) return []

//   // Step 1: Determine the earliest start date and the latest end date
//   const startDate = dayjs.min(deal.products.map(product => dayjs(product.startDate)))
//   const endDate = dayjs.max(deal.products.map(product => dayjs(product.endDate)))

//   // Step 2: Calculate the total number of months between the start and end dates
//   const totalPayments = deal && deal.numberOfPayments ? deal.numberOfPayments : 2

//   // Step 3: Calculate the total contract amount
//   const totalAmount = deal.products.reduce((sum, product) => sum + parseFloat(product.price), 0)

//   // Step 4: Calculate the monthly payment amount
//   const monthlyPayment = (totalAmount / totalPayments).toFixed(2)

//   // Step 5: Generate the payment schedule
//   const paymentSchedule = []
//   let currentMonth = startDate.startOf('month')

//   for (let i = 0; i < totalPayments; i++) {
//     paymentSchedule.push({
//       month: currentMonth.format('MMMM'),
//       year: currentMonth.year(),
//       paymentAmount: parseFloat(monthlyPayment),
//       productsAssociated: deal.products.map(product => product.productName), // or customize as needed
//     })
//     currentMonth = currentMonth.add(1, 'month')
//   }

//   return paymentSchedule
// }
